/**
 * TvLabel — Inter Tight section title used inside card headers
 * and form-section dividers.
 *
 *   <TvLabel>Today's tasks</TvLabel>
 *
 * Spec: Inter Tight · 14px · 600 · ink · tracking -0.01em.
 */
import React from 'react';
import { tvTokens } from './tokens';

interface TvLabelProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Optional size override — defaults to "md" (14px). "lg" is 15px for NBA cards. */
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

const SIZES: Record<NonNullable<TvLabelProps['size']>, number> = {
  sm: 12,
  md: 14,
  lg: 15,
};

export function TvLabel({ size = 'md', children, style, ...rest }: TvLabelProps) {
  return (
    <span
      {...rest}
      style={{
        fontFamily: tvTokens.fontDisplay,
        fontSize: SIZES[size],
        fontWeight: 600,
        letterSpacing: '-0.01em',
        color: tvTokens.ink,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
